export interface Bank {
    name: string;
    code: string;
    ispb: string;
}

export const OTHER_BANK_CODE = '__other__';

const RAW_BANKS: Bank[] = [
    { name: 'Acesso Soluções De Pagamento S.A.', code: '332', ispb: '13140088' },
    { name: 'Advanced Corretora De Câmbio Ltda', code: '117', ispb: '92856905' },
    { name: 'Avista S.A. Crédito', code: '280', ispb: '23862762' },
    { name: 'Agk Corretora De Cambio S.A.', code: '272', ispb: '250699' },
    { name: 'Al5 S.A. Crédito', code: '349', ispb: '27214112' },
    { name: 'Amazónia Corretora De Câmbio Ltda.', code: '313', ispb: '16927221' },
    { name: 'Ativa Investimentos S.A. Corretora De Títulos, Câmbio E Valores', code: '188', ispb: '33775974' },
    { name: 'B&T Corretora De Cambio Ltda.', code: '080', ispb: '73622748' },
    { name: 'Banco Abc Brasil S.A.', code: '246', ispb: '28195667' },
    { name: 'Banco Abn Amro S.A.', code: '075', ispb: '3532415' },
    { name: 'Banco Agibank S.A.', code: '121', ispb: '10664513' },
    { name: 'Banco Alfa S.A.', code: '025', ispb: '3323840' },
    { name: 'Banco Andbank (Brasil) S.A.', code: '065', ispb: '48795256' },
    { name: 'Banco Arbi S.A.', code: '213', ispb: '54403563' },
    { name: 'Banco B3 S.A.', code: '096', ispb: '997185' },
    { name: 'Banco Bandepe S.A.', code: '024', ispb: '10866788' },
    { name: 'Banco Bari De Investimentos E Financiamentos S.A.', code: '330', ispb: '556603' },
    { name: 'Banco BMG S.A.', code: '318', ispb: '61186680' },
    { name: 'Banco Bnp Paribas Brasil S.A.', code: '752', ispb: '1522368' },
    { name: 'Banco Bocom Bbm S.A.', code: '107', ispb: '15114366' },
    { name: 'Banco Bradescard S.A.', code: '063', ispb: '4184779' },
    { name: 'Banco Bradesco BBI S.A.', code: '036', ispb: '6271464' },
    { name: 'Banco Bradesco Berj S.A.', code: '122', ispb: '33147315' },
    { name: 'Banco Bradesco Financiamentos S.A.', code: '394', ispb: '7207996' },
    { name: 'Banco Bradesco S.A.', code: '237', ispb: '60746948' },
    { name: 'Banco Bs2 S.A.', code: '218', ispb: '71027866' },
    { name: 'Banco BTG Pactual S.A.', code: '208', ispb: '30306294' },
    { name: 'Banco C6 Consignado S.A.', code: '626', ispb: '61348538' },
    { name: 'Banco C6 S.A.', code: '336', ispb: '31872495' },
    { name: 'Banco Caixa Geral - Brasil S.A.', code: '473', ispb: '33466988' },
    { name: 'Banco Capital S.A.', code: '412', ispb: '15173776' },
    { name: 'Banco Cargill S.A.', code: '040', ispb: '3609817' },
    { name: 'Banco Cedula S.A.', code: '266', ispb: '33132044' },
    { name: 'Banco Cetelem S.A.', code: '739', ispb: '558456' },
    { name: 'Banco Cetelem S.A.', code: '233', ispb: '62421979' },
    { name: 'Banco Citibank S.A.', code: '745', ispb: '33479023' },
    { name: 'Banco Classico S.A.', code: '241', ispb: '31597552' },
    { name: 'Banco Cooperativo Do Brasil S.A. - Bancoob - Sicoob', code: '756', ispb: '2038232' },
    { name: 'Banco Cooperativo Sicredi S.A.', code: '748', ispb: '1181521' },
    { name: 'Banco Crédit Agricole Brasil S.A.', code: '222', ispb: '75647891' },
    { name: 'Banco Credit Suisse (Brasil) S.A.', code: '505', ispb: '32062580' },
    { name: 'Banco Crefisa S.A.', code: '069', ispb: '61033106' },
    { name: 'Banco CSF S.A.', code: '368', ispb: '8357240' },
    { name: 'Banco da Amazonia S.A.', code: '003', ispb: '4902979' },
    { name: 'Banco da China Brasil S.A.', code: '083', ispb: '10690848' },
    { name: 'Banco Daycoval S.A.', code: '707', ispb: '62232889' },
    { name: 'Banco De La Nacion Argentina', code: '300', ispb: '33042151' },
    { name: 'Banco De La Provincia De Buenos Aires', code: '495', ispb: '44189447' },
    { name: 'Banco Digimais S.A.', code: '654', ispb: '92874270' },
    { name: 'Banco Digio S.A.', code: '335', ispb: '27098060' },
    { name: 'Banco do Brasil S.A.', code: '001', ispb: '00000000' },
    { name: 'Banco Do Estado De Sergipe S.A.', code: '047', ispb: '13009717' },
    { name: 'Banco Do Estado Do Pará S.A.', code: '037', ispb: '4913711' },
    { name: 'Banco Do Estado Do Rio Grande Do Sul S.A.', code: '041', ispb: '92702067' },
    { name: 'Banco Do Nordeste Do Brasil S.A.', code: '004', ispb: '7237373' },
    { name: 'Banco Fator S.A.', code: '265', ispb: '33644196' },
    { name: 'Banco Fibra S.A.', code: '224', ispb: '58616418' },
    { name: 'Banco Finaxis S.A.', code: '094', ispb: '11758741' },
    { name: 'Banco Gm S.A.', code: '390', ispb: '59274605' },
    { name: 'Banco Guanabara S.A.', code: '612', ispb: '31880826' },
    { name: 'Banco HSBC S.A.', code: '269', ispb: '53518684' },
    { name: 'Banco Inbursa S.A.', code: '012', ispb: '4866275' },
    { name: 'Banco Industrial Do Brasil S.A.', code: '604', ispb: '31895683' },
    { name: 'Banco Indusval S.A.', code: '653', ispb: '61024352' },
    { name: 'Banco Inter S.A.', code: '077', ispb: '416968' },
    { name: 'Banco Investcred Unibanco S.A.', code: '249', ispb: '61182408' },
    { name: 'Banco Itaú BBA S.A.', code: '184', ispb: '17298092' },
    { name: 'Banco Itaú Consignado S.A.', code: '029', ispb: '33885724' },
    { name: 'Banco Itaubank S.A.', code: '479', ispb: '60394079' },
    { name: 'Banco J. Safra S.A.', code: '074', ispb: '3017677' },
    { name: 'Banco J.P. Morgan S.A.', code: '376', ispb: '33172537' },
    { name: 'Banco John Deere S.A.', code: '217', ispb: '91884981' },
    { name: 'Banco Kdb Do Brasil S.A.', code: '076', ispb: '7656500' },
    { name: 'Banco Keb Hana Do Brasil S.A.', code: '757', ispb: '2318507' },
    { name: 'Banco Luso Brasileiro S.A.', code: '600', ispb: '59118133' },
    { name: 'Banco Máxima S.A.', code: '243', ispb: '33923798' },
    { name: 'Banco Mercantil do Brasil S.A.', code: '389', ispb: '17184037' },
    { name: 'Banco Mercedes-Benz Do Brasil S.A.', code: '381', ispb: '60814191' },
    { name: 'Banco Mizuho Do Brasil S.A.', code: '370', ispb: '61088183' },
    { name: 'Banco Modal S.A.', code: '746', ispb: '30723886' },
    { name: 'Banco Morgan Stanley S.A.', code: '066', ispb: '2801938' },
    { name: 'Banco Mufg Brasil S.A.', code: '456', ispb: '60498557' },
    { name: 'Banco Nacional De Desenvolvimento Economico E Social', code: '007', ispb: '33657248' },
    { name: 'Banco Olé Consignado S.A.', code: '169', ispb: '71371686' },
    { name: 'Banco Original Do Agronegócio S.A.', code: '079', ispb: '9516419' },
    { name: 'Banco Original S.A.', code: '212', ispb: '92894922' },
    { name: 'Banco Ourinvest S.A.', code: '712', ispb: '78632767' },
    { name: 'Banco Pan S.A.', code: '623', ispb: '59285411' },
    { name: 'Banco Paulista S.A.', code: '611', ispb: '61820817' },
    { name: 'Banco Pine S.A.', code: '643', ispb: '62144175' },
    { name: 'Banco Rabobank International Brasil S.A.', code: '747', ispb: '1023570' },
    { name: 'Banco Randon S.A.', code: '088', ispb: '11476673' },
    { name: 'Banco Rendimento S.A.', code: '633', ispb: '68900810' },
    { name: 'Banco Ribeirao Preto S.A.', code: '741', ispb: '517645' },
    { name: 'Banco Rodobens S.A.', code: '120', ispb: '33603457' },
    { name: 'Banco Safra S.A.', code: '422', ispb: '58160789' },
    { name: 'Banco Santander (Brasil) S.A.', code: '033', ispb: '90400888' },
    { name: 'Banco Semear S.A.', code: '743', ispb: '795423' },
    { name: 'Banco Sistema S.A.', code: '754', ispb: '76543115' },
    { name: 'Banco Smartbank S.A.', code: '630', ispb: '58497702' },
    { name: 'Banco Societe Generale Brasil S.A.', code: '366', ispb: '61533584' },
    { name: 'Banco Sofisa S.A.', code: '637', ispb: '60889128' },
    { name: 'Banco Sumitomo Mitsui Brasileiro S.A.', code: '464', ispb: '60518222' },
    { name: 'Banco Topázio S.A.', code: '082', ispb: '7679404' },
    { name: 'Banco Toyota Do Brasil S.A.', code: '387', ispb: '3215790' },
    { name: 'Banco Triangulo S.A.', code: '634', ispb: '17351180' },
    { name: 'Banco Tricury S.A.', code: '018', ispb: '57839805' },
    { name: 'Banco Volkswagen S.A.', code: '393', ispb: '59109165' },
    { name: 'Banco Votorantim S.A.', code: '655', ispb: '59588111' },
    { name: 'Banco Vr S.A.', code: '610', ispb: '78626983' },
    { name: 'Banco Western Union Do Brasil S.A.', code: '119', ispb: '13720915' },
    { name: 'Banco Woori Bank Do Brasil S.A.', code: '124', ispb: '15357060' },
    { name: 'Banco Xp S.A.', code: '348', ispb: '33264668' },
    { name: 'Bancoseguro S.A.', code: '081', ispb: '10264663' },
    { name: 'Banestes S.A. Banco Do Estado do Espirito Santo', code: '021', ispb: '28127603' },
    { name: 'Bank of America Merrill Lynch Banco Múltiplo S.A.', code: '755', ispb: '62073200' },
    { name: 'Bari Companhia Hipotecária', code: '268', ispb: '14511781' },
    { name: 'Bbc Leasing S.A. - Arrendamento Mercantil', code: '378', ispb: '1852137' },
    { name: 'Bcv - Banco De Crédito E Varejo S.A.', code: '250', ispb: '50585090' },
    { name: 'Bexs Banco De Câmbio S/A', code: '144', ispb: '13059145' },
    { name: 'Bexs Corretora De Câmbio S/A', code: '253', ispb: '52937216' },
    { name: 'Bgc Liquidez Distribuidora De Títulos E Valores Mobiliários Ltda', code: '134', ispb: '33862244' },
    { name: 'Bny Mellon Banco S.A.', code: '017', ispb: '42272526' },
    { name: 'Bónuscred Sociedade De Crédito Direto S.A.', code: '408', ispb: '36586946' },
    { name: 'Bpp Instituição De Pagamento S.A.', code: '301', ispb: '13370835' },
    { name: 'Br Partners Banco De Investimento S.A.', code: '126', ispb: '13220493' },
    { name: 'BrB - Banco De Brasilia S.A.', code: '070', ispb: '208' },
    { name: 'Brk S.A. Crédito', code: '092', ispb: '12865507' },
    { name: 'Brl Trust Distribuidora De Títulos E Valores Mobiliários S.A.', code: '173', ispb: '13486793' },
    { name: 'Broker Brasil Corretora De Câmbio Ltda.', code: '142', ispb: '16944141' },
    { name: 'Bs2 Distribuidora De Títulos E Valores Mobiliários S.A.', code: '292', ispb: '28650236' },
    { name: 'Caixa Economica Federal', code: '104', ispb: '360305' },
    { name: 'Cambionet Corretora De Câmbio Ltda.', code: '309', ispb: '14190547' },
    { name: 'Carol Distribuidora De Titulos E Valores Mobiliarios Ltda.', code: '288', ispb: '62237649' },
    { name: 'Cartos Sociedade De Crédito Direto S.A.', code: '324', ispb: '21332862' },
    { name: 'Caruana S.A. - Sociedade De Crédito', code: '130', ispb: '9313766' },
    { name: 'Casa Do Crédito S.A. Sociedade De Crédito Ao Microempreendedor', code: '159', ispb: '5442029' },
    { name: 'Central Cooperativa De Crédito No Estado Do Espírito Santo - Cecoop', code: '114', ispb: '5790149' },
    { name: 'Central De Cooperativas De Economia E Crédito Mútuo Do Estado Do Rio Grande Do Sul', code: '091', ispb: '1634601' },
    { name: 'China Construction Bank (Brasil) Banco Múltiplo S.A.', code: '320', ispb: '7450604' },
    { name: 'Cielo S.A.', code: '362', ispb: '1027058' },
    { name: 'Citibank N.A.', code: '477', ispb: '33042953' },
    { name: 'Cm Capital Markets Corretora De Câmbio, Títulos E Valores Mobiliários Ltda', code: '180', ispb: '2685483' },
    { name: 'Codepe Corretora De Valores E Câmbio S.A.', code: '127', ispb: '9512542' },
    { name: 'Commerzbank Brasil S.A. - Banco Múltiplo', code: '163', ispb: '23522214' },
    { name: 'Banco Cresol - Confederação Nacional Das Cooperativas Centrais De Crédito e Economia Familiar e Solidária', code: '133', ispb: '10398952' },
    { name: 'Unicred Do Brasil - Confederação Nacional Das Cooperativas Centrais Unicred Ltda.', code: '136', ispb: '315557' },
    { name: 'Confidence Corretora De Câmbio S.A.', code: '060', ispb: '4913129' },
    { name: 'Cooperativa Central De Crédito - Ailos', code: '085', ispb: '5463212' },
    { name: 'Cooperativa de Crédito Mutuo dos Despachantes de Trânsito de Santa Catarina e Rio Grande do Sul', code: '16', ispb: '4715685' },
    { name: 'Cooperativa De Crédito Rural Coopavel', code: '281', ispb: '76461557' },
    { name: 'Cooperativa De Crédito Rural De Abelardo Luz - Sulcredi/Crediluz', code: '322', ispb: '1073966' },
    { name: 'Cooperativa De Credito Rural De Ibiam - Sulcredi/Ibiam', code: '391', ispb: '8240446' },
    { name: 'Cooperativa De Crédito Rural De Ouro Sulcredi/Ouro', code: '286', ispb: '7853842' },
    { name: 'Cooperativa De Credito Rural De Primavera Do Leste', code: '279', ispb: '26563270' },
    { name: 'Cooperativa De Crédito Rural De São Miguel Do Oeste - Sulcredi/São Miguel', code: '273', ispb: '8253539' },
    { name: 'Cora Sociedade De Crédito Direto S.A.', code: '403', ispb: '37880206' },
    { name: 'Credialiança Cooperativa De Crédito Rural', code: '098', ispb: '78157146' },
    { name: 'Credicoamo Credito Rural Cooperativa', code: '010', ispb: '81723108' },
    { name: 'Credisan Cooperativa De Crédito', code: '089', ispb: '62109566' },
    { name: 'Credisis - Central De Cooperativas De Crédito Ltda.', code: '097', ispb: '4632856' },
    { name: 'Credit Suisse Hedging-Griffo Corretora De Valores S.A', code: '011', ispb: '61809182' },
    { name: 'Creditas Sociedade De Crédito Direto S.A.', code: '342', ispb: '32997490' },
    { name: 'Crefaz Sociedade De Crédito Ao Microempreendedor E A Empresa De Pequeno Porte Lt', code: '321', ispb: '18188384' },
    { name: 'Decyseo Corretora De Cambio Ltda.', code: '289', ispb: '94968518' },
    { name: 'Deutsche Bank S.A. - Banco Alemao', code: '487', ispb: '62331228' },
    { name: 'Easynvest - Título Corretora De Valores Sa', code: '140', ispb: '62169875' },
    { name: 'Facta Financeira S.A. - Crédito Financiamento e Investimento', code: '149', ispb: '15581638' },
    { name: 'Fair Corretora De Cambio S.A.', code: '196', ispb: '32648370' },
    { name: 'Ffa Sociedade De Crédito Ao Microempreendedor E À Empresa De Pequeno Porte Ltda.', code: '343', ispb: '24537861' },
    { name: 'Fram Capital Distribuidora De Títulos E Valores Mobiliários S.A.', code: '331', ispb: '13673855' },
    { name: 'Frente Corretora De Câmbio Ltda.', code: '285', ispb: '71677850' },
    { name: 'Genial Investimentos Corretora De Valores Mobiliários S.A.', code: '278', ispb: '27652684' },
    { name: 'Gerencianet S.A.', code: '364', ispb: '9089356' },
    { name: 'Get Money Corretora De Câmbio S.A.', code: '138', ispb: '10853017' },
    { name: 'Global Financas - Sociedade De Credito Ao Microempreendedor E A Empresa De Pequeno Porte Ltda', code: '384', ispb: '11165756' },
    { name: 'Goldman Sachs Do Brasil Banco Multiplo S.A.', code: '064', ispb: '4332281' },
    { name: 'Guide Investimentos S.A. Corretora De Valores', code: '177', ispb: '65913436' },
    { name: 'Guitta Corretora De Cambio Ltda.', code: '146', ispb: '24074692' },
    { name: 'Haitong Banco De Investimento Do Brasil S.A.', code: '078', ispb: '34111187' },
    { name: 'Hipercard Banco Múltiplo S.A.', code: '062', ispb: '3012230' },
    { name: 'HS Financeira S/A Credito', code: '189', ispb: '7512441' },
    { name: 'Hub Pagamentos S.A', code: '396', ispb: '13884775' },
    { name: 'Ib Corretora De Câmbio, Títulos E Valores Mobiliários S.A.', code: '271', ispb: '27842177' },
    { name: 'Icap Do Brasil Corretora De Títulos E Valores Mobiliários Ltda.', code: '157', ispb: '9105360' },
    { name: 'Icbc Do Brasil Banco Múltiplo S.A.', code: '132', ispb: '17453575' },
    { name: 'Ing Bank N.V.', code: '492', ispb: '49336860' },
    { name: 'Intesa Sanpaolo Brasil S.A. - Banco Múltiplo', code: '139', ispb: '55230916' },
    { name: 'Itaú Unibanco Holding S.A.', code: '652', ispb: '60872504' },
    { name: 'Itaú Unibanco S.A.', code: '341', ispb: '60701190' },
    { name: 'Jpmorgan Chase Bank', code: '488', ispb: '46518205' },
    { name: 'Kirton Bank S.A. - Banco Múltiplo', code: '399', ispb: '1701201' },
    { name: 'Lastro Rdv Distribuidora De Títulos E Valores Mobiliários Ltda.', code: '293', ispb: '71590442' },
    { name: 'Lecca Crédito', code: '105', ispb: '7652226' },
    { name: 'Levycam - Corretora De Cambio E Valores Ltda.', code: '145', ispb: '50579044' },
    { name: 'Listo Sociedade De Credito Direto S.A.', code: '397', ispb: '34088029' },
    { name: 'Magliano S.A. Corretora De Cambio E Valores Mobiliarios', code: '113', ispb: '61723847' },
    { name: 'Mercadopago.Com Representacoes Ltda.', code: '323', ispb: '10573521' },
    { name: 'Money Plus Sociedade De Crédito ao Microempreendedor e a Empresa De Pequeno Port', code: '274', ispb: '11581339' },
    { name: 'Moneycorp Banco De Câmbio S.A.', code: '259', ispb: '8609934' },
    { name: 'Ms Bank S.A. Banco De Câmbio', code: '128', ispb: '19307785' },
    { name: 'Necton Investimentos S.A. Corretora de Valores Mobiliários e Commodities', code: '354', ispb: '52904364' },
    { name: 'Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.', code: '191', ispb: '4257795' },
    { name: 'Novo Banco Continental S.A. - Banco Múltiplo', code: '753', ispb: '74828799' },
    { name: 'Nu Pagamentos S.A.', code: '260', ispb: '18236120' },
    { name: 'Oliveira Trust Distribuidora de Títulos e Valores Mobiliarios S.A.', code: '111', ispb: '36113876' },
    { name: 'Om Distribuidora de Títulos e Valores Mobiliários Ltda', code: '319', ispb: '11495073' },
    { name: 'Omni Banco S.A.', code: '613', ispb: '60850229' },
    { name: 'Órama Distribuidora de Títulos e Valores Mobiliários S.A.', code: '325', ispb: '13293225' },
    { name: 'Ótimo Sociedade de Crédito Direto S.A.', code: '355', ispb: '34335592' },
    { name: 'Pagseguro Internet S.A.', code: '290', ispb: '8561701' },
    { name: 'Paraná Banco S.A.', code: '254', ispb: '14388334' },
    { name: 'Parati - Credito', code: '326', ispb: '3311443' },
    { name: 'Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda', code: '194', ispb: '20155248' },
    { name: 'Pefisa S.A. - Crédito', code: '174', ispb: '43180355' },
    { name: 'Pi Distribuidora de Títulos e Valores Mobiliários S.A.', code: '315', ispb: '3502968' },
    { name: 'Picpay Servicos S.A.', code: '380', ispb: '22896431' },
    { name: 'Planner Corretora de Valores S.A.', code: '100', ispb: '806535' },
    { name: 'Plural S.A. Banco Múltiplo', code: '125', ispb: '45246410' },
    { name: 'Portocred S.A. - Credito', code: '108', ispb: '1800019' },
    { name: 'Portopar Distribuidora de Titulos e Valores Mobiliarios Ltda.', code: '306', ispb: '40303299' },
    { name: 'Qi Sociedade de Crédito Direto S.A.', code: '306', ispb: '40303299' },
    { name: 'Qi Sociedade de Crédito Direto S.A.', code: '329', ispb: '32402502' },
    { name: 'Rb Capital Investimentos Distribuidora de Títulos e Valores Mobiliários Limitada', code: '283', ispb: '89960090' },
    { name: 'Realize Crédito', code: '374', ispb: '27351731' },
    { name: 'Renascenca Distribuidora de Títulos e Valores Mobiliários Ltda', code: '101', ispb: '62287735' },
    { name: 'Sagitur Corretora De Câmbio Ltda.', code: '270', ispb: '61444949' },
    { name: 'Scotiabank Brasil S.A. Banco Múltiplo', code: '751', ispb: '29030467' },
    { name: 'Senff S.A. - Crédito', code: '276', ispb: '11970623' },
    { name: 'Senso Corretora De Cambio E Valores Mobiliarios S.A', code: '545', ispb: '17352220' },
    { name: 'Servicoop - Cooperativa De Crédito Dos Servidores Públicos Estaduais Do Rio Grande Do Sul', code: '190', ispb: '3973814' },
    { name: 'Socopa Sociedade Corretora Paulista S.A.', code: '363', ispb: '62285390' },
    { name: 'Socred S.A. - Sociedade De Crédito Ao Microempreendedor e a Empresa De Pequeno Porte', code: '183', ispb: '9210106' },
    { name: 'Solidus S.A. Corretora de Cambio e Valores Mobiliarios', code: '365', ispb: '68757681' },
    { name: 'Sorocred Crédito', code: '299', ispb: '4814563' },
    { name: 'State Street Brasil S.A. - Banco Comercial', code: '014', ispb: '9274232' },
    { name: 'Stone Pagamentos S.A.', code: '197', ispb: '16501555' },
    { name: 'Sumup Sociedade De Crédito Direto S.A.', code: '404', ispb: '37241230' },
    { name: 'Super Pagamentos e Administração de Meios Eletrônicos S.A.', code: '340', ispb: '9554480' },
    { name: 'Terra Investimentos Distribuidora de Títulos e Valores Mobiliários Ltda.', code: '370', ispb: '3751794' },
    { name: 'Toro Corretora De Títulos E Valores Mobiliários Ltda', code: '352', ispb: '29162769' },
    { name: 'Travelex Banco De Câmbio S.A.', code: '095', ispb: '11703662' },
    { name: 'Treviso Corretora De Câmbio S.A.', code: '143', ispb: '2992317' },
    { name: 'Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda', code: '131', ispb: '61747085' },
    { name: 'Ubs Brasil Banco de Investimento S.A.', code: '129', ispb: '18520834' },
    { name: 'Ubs Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.', code: '015', ispb: '2819125' },
    { name: 'Uniprime Central - Central Interestadual De Cooperativas de Credito Ltda.', code: '099', ispb: '3046391' },
    { name: 'Uniprime Norte Do Paraná - Coop de Economia e Crédito Mútuo Dos Médicos', code: '084', ispb: '2398976' },
    { name: "UP.P Sociedade de Empréstimo Entre Pessoas S.A.", code: '373', ispb: '35977097' },
    { name: "Vip's Corretora de Câmbio Ltda.", code: '298', ispb: '17772370' },
    { name: 'Vision S.A. Corretora De Cambio', code: '296', ispb: '4062902' },
    { name: 'Vitreo Distribuidora de Títulos e Valores Mobiliários S.A.', code: '367', ispb: '34711571' },
    { name: 'Vortx Distribuidora de Titulos e Valores Mobiliarios Ltda.', code: '310', ispb: '22610500' },
    { name: 'Xp Investimentos Corretora de Câmbio,Títulos d Valores Mobiliários S/A', code: '102', ispb: '2332886' },
    { name: 'Zema Crédito', code: '359', ispb: '5351887' },
];

// The Sign API expects a 3-digit zero-padded bank code (e.g. "003", not "3");
// the source list has at least one entry ("16") that isn't padded.
export const BANKS: Bank[] = RAW_BANKS.map((bank) => ({ ...bank, code: bank.code.padStart(3, '0') }));

export const findBankByCode = (code: string): Bank | undefined =>
    BANKS.find((bank) => bank.code === code);

const DIACRITICS_REGEX = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');

const normalize = (value: string) =>
    value
        .normalize('NFD')
        .replace(DIACRITICS_REGEX, '')
        .toLowerCase()
        .trim();

const isSubsequence = (query: string, target: string) => {
    let i = 0;
    for (let j = 0; j < target.length && i < query.length; j += 1) {
        if (target[j] === query[i]) i += 1;
    }
    return i === query.length;
};

const matchScore = (bank: Bank, normalizedQuery: string) => {
    const normalizedName = normalize(bank.name);
    if (bank.code === normalizedQuery) return 0;
    if (normalizedName.startsWith(normalizedQuery)) return 1;
    if (bank.code.startsWith(normalizedQuery)) return 2;
    const index = normalizedName.indexOf(normalizedQuery);
    if (index >= 0) return 3 + index / 1000;
    if (isSubsequence(normalizedQuery, normalizedName)) return 10;
    return -1;
};

export const searchBanks = (query: string): Bank[] => {
    const normalizedQuery = normalize(query);
    if (!normalizedQuery) return BANKS;

    return BANKS
        .map((bank) => ({ bank, score: matchScore(bank, normalizedQuery) }))
        .filter(({ score }) => score >= 0)
        .sort((a, b) => a.score - b.score)
        .map(({ bank }) => bank);
};
